import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../App';
import '../../OSUWMC/project.css'
import api from '../FetchComponents/FetchComponentsServices';

function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
function getTimeInQueue(dateAdded) {
    if (!dateAdded) return '';
    const now = new Date();
    const added = new Date(dateAdded);
    const diffMs = now - added;

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays > 0) return `${diffDays} day${diffDays > 1 ? 's' : ''}`;

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffHours > 0) return `${diffHours} hour${diffHours > 1 ? 's' : ''}`;

    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    if (diffMinutes > 0) return `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;

    return 'just now';
}

const ErrorsQueue = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const setApiMessage = useContext(AppContext).setApiMessage;

    const fetchErrorTable = () => {
        setIsLoading(true);
        api.GetErrors()
            .then((data) => {
                setErrors(data);
            })
            .catch(() => {
                setApiMessage('Error loading error data');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchErrorTable();
    }, []);

    return (
        <article>
            <h1 className="page-title">Errors Needing Resolution</h1>
            <div className="report-grid">
                <div className="grid-header" aria-hidden="true">
                    <span>Workforce ID</span>
                    <span>Matrix Person ID</span>
                    <span>OSUidm ID</span>
                    <span>Last Name</span>
                    <span>First Name</span>
                    <span>Error Message</span>
                    <span>Date Added</span>
                    <span>Time in Queue</span>
                </div>
                <div className="grid-returns">
                    <ul>
                        {errors.map((error, idx) => (
                            <li key={idx}>
                                <p>
                                    <span className="visually-hidden">Workforce ID:</span> {error.workforceID}
                                </p>
                                <p>
                                    <span className="visually-hidden">Matrix Person ID:</span> {error.personID}
                                </p>
                                <p>
                                    <span className="visually-hidden">OSUidm ID:</span> {error.osUidmId}
                                </p>
                                <p>
                                    <span className="visually-hidden">Last Name:</span> {error.lastName}
                                </p>
                                <p>
                                    <span className="visually-hidden">First Name:</span> {error.firstName}
                                </p>
                                <p>
                                    <span className="visually-hidden">Error Message:</span> {error.message}
                                </p>
                                <p>
                                    <span className="visually-hidden">Date Added:</span> {formatDate(error.dateAdded)}
                                </p>
                                <p>
                                    <span className="visually-hidden">Time in Queue:</span> {getTimeInQueue(error.dateAdded)}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </article>
    )
}
export default ErrorsQueue;